import { render, staticRenderFns } from "./play-square.vue?vue&type=template&id=4a10b98a&scoped=true&"
import script from "./play-square.vue?vue&type=script&lang=js&"
export * from "./play-square.vue?vue&type=script&lang=js&"
import style0 from "./play-square.vue?vue&type=style&index=0&id=4a10b98a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a10b98a",
  null
  
)

export default component.exports